import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import Modal from "react-modal";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal } from "antd";
import html2pdf from "html2pdf.js";
import { useAuth } from "../../../store/auth";

const SalesOrderList = (props) => {
  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px", // Adjust the width as needed
      height: "80%",
      minHeight: "400px",
      overflow: "auto",
      // border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    const id = (data && data.salesOrderId) || 0;

    getSalesOrder(
      {
        url: `/api/salesOrder/?salesOrderId=${id}&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          setSelectedData(res[0]);
        }
      }
    );

    setIsModalOpen(true);
  };

  const { addForm, update } = props;
  const { orgData } = useAuth();
  const [data, setData] = useState([]);
  const [docurl, setDocUrl] = useState(false);
  const [salesOrderId, setSalesOrderId] = useState([]);
  const [allData, setAllData] = useState([]);

  const { sendRequest: getSalesOrder } = useHttp();

  const getData = () => {
    getSalesOrder(
      {
        url: `/api/salesOrder/?orgId=${localStorage.getItem("orgId")}&empId=${localStorage.getItem("empId")}`,
      },
      (res) => {
        if (res) {
          setData(res);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    getData();
  }, []);

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();

    var filterdata = allData.filter(
      (item) =>
        item.salesOrderCode.includes(filetrtext) ||
        item.name.includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: deleteSalesOrder } = useHttp();

  const handleDelete = (e, salesOrderId) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this Sales Order detail?",
      onOk() {
        const data = {
          salesOrderId: salesOrderId,
        };

        deleteSalesOrder(
          {
            url: "/api/salesOrder/",
            method: "DELETE",
            body: data,
          },
          (data) => {
            toast.success("Order Deleted Successfully");
            getData();
          }
        );
      },
      onCancel() {
        // Do nothing if the user cancels the delete action.
      },
    });
  };

  function extractAndFormatDate(inputDate) {
    const date = new Date(inputDate);

    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    const formattedDate = date.toLocaleDateString(undefined, options);

    return formattedDate;
  }

  const pdfContainerRef = useRef(null);
  const [pdfView, setPdfView] = useState(false);
  const [pdfData, setPdfData] = useState([]);

  const viewPdf = (data) => {
    setPdfView(true);
    if (data) {
      setPdfData(data);
    }
  };

  const printPdfContainer = () => {
    const elementsToHide = document.querySelectorAll(".no-print");
    elementsToHide.forEach((element) => {
      element.style.display = "none !important";
    });
    document.body.style.overflow = "visible";

    window.print();
    document.body.style.overflow = "";
    elementsToHide.forEach((element) => {
      element.style.display = "";
    });
  };

  const generatePDF = (salesOrderCode) => {
    const input = pdfContainerRef.current;

    const pdfName = salesOrderCode || "Sales order";

    html2pdf(input, {
      margin: 10,
      filename: `${pdfName}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
      pagebreak: { mode: "avoid-all" },
    });
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">Sales Order</label>
          </div>

          <div className="col-6 text-right">
            <button
              type="button"
              className="btn  btn-primary mx-3 my-3"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Add Sales Order
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row ">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-4"> </div>

                      <div className="col-4">
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />
                      </div>
                    </div>
                    <br />
                    <table className="table table-bordered table-sm text-center">
                      <thead>
                        <tr>
                          <th>Order Date</th>
                          <th>Sales order No</th>
                          <th>Customer Name</th>
                          <th>Contact Person Name</th>
                          <th>Total Sales order Value</th>
                          <th>Invoice Status</th>
                          <th>Sales Return</th>
                          <th>Edit</th>
                          <th>Delete</th>
                          <th>View</th>
                          {/* <th>Pdf</th> */}
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((x, i) => {
                            return (
                              <tr key={i}>
                                <td>{x.date}</td>
                                <td>{x.salesOrderCode}</td>
                                <td>{x.name}</td>
                                <td>{x.customerContactPersonName}</td>
                                <td>{x.totalSalesOrderValue}</td>
                                <td>{x.invoiceStatus}</td>
                                <td>{x.salesReturnStatus}</td>

                                <td>
                                  {x.invoiceStatus === "Yes" ? (
                                    <button className="btn" disabled>
                                      <i className="fas fa-edit"></i>
                                    </button>
                                  ) : (
                                    <button
                                      onClick={() => {
                                        props.update(x);
                                        props.addForm(true);
                                      }}
                                      className="btn"
                                    >
                                      <i className="fas fa-edit"></i>
                                    </button>
                                  )}
                                </td>
                                <td>
                                  {x.invoiceStatus === "Yes" ? (
                                    <button className="btn" disabled>
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  ) : (
                                    <button
                                      className="btn"
                                      onClick={(e) =>
                                        handleDelete(e, x.salesOrderId)
                                      }
                                    >
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  )}
                                </td>
                                {/* <td>
                                  <button
                                    className="btn"
                                    onClick={() => openModal(x)}
                                  >
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td> */}
                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => viewPdf(x)}
                                  >
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {/* view modal */}
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div className="mx-3">
            <h4 className="card-title">Sales Order Details</h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>

            <div className="row">
              <p className="col-md-6">
                Sales Order No: {selectedData.salesOrderCode}
              </p>
              <p className="col-md-6">Sales Order Date : {selectedData.date}</p>
            </div>
            <div className="row">
              <p className="col-md-6">Customer Name: {selectedData.name}</p>

              <p className="col-md-6">
                Contact Person Name : {selectedData.customerContactPersonName}
              </p>
            </div>

            <div className="row">
              <p className="col-md-6">
                Work Contact Number: {selectedData.workContactNumber}
              </p>
              <p className="col-md-6">
                Whatsapp Number : {selectedData.whatsappNumber}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Customer Email: {selectedData.customerEmailId}
              </p>
              <p className="col-md-6">
                Sales Executive Name: {selectedData.executiveName}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Sales Invoice Status: {selectedData.invoiceStatus}
              </p>
              <p className="col-md-6">
                Sales Return Status: {selectedData.salesReturnStatus}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Expected Delivery Date: {selectedData.expectedDate || " "}
              </p>
              <p className="col-md-6">
                Delievry Dispatch Status : {selectedData.delievryDispatchStatus}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                BillingAddress: {selectedData.billingAddress} ,
                {selectedData.billingCity}, {selectedData.billingState},{" "}
                {selectedData.billingCountry}, {selectedData.billingZip}.
              </p>
              <p className="col-md-6">
                Shipping Address: {selectedData.shippingAddress},
                {selectedData.shippingCity}, {selectedData.shippingState},{" "}
                {selectedData.shippingCountry}, {selectedData.shippingZip}.
              </p>
            </div>

            <h5>Product Details</h5>
            <table className="table table-bordered table-responsive table-sm text-center">
              <thead>
                <tr>
                  <th>Sr. No</th>

                  <th>Item Category</th>
                  <th>Item Description</th>
                  <th>Item Unit Price</th>
                  <th>Rate</th>
                  <th>Item Quantity</th>
                  <th>Unit</th>
                  <th>Amount</th>
                  <th>Discount</th>
                  <th>Discount Amount</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {selectedData.salesOrderProducts &&
                  selectedData.salesOrderProducts.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{itm.lineSrNo}</td>

                        <td>{itm.productSubTypeName}</td>
                        <td>{itm.productName}</td>
                        <td>{itm.itemUnitPrice}</td>
                        <td>{itm.rate}</td>
                        <td>{itm.salesOrderQuantity}</td>
                        <td>{itm.unitAbbreviation}</td>
                        <td>{itm.subTotalAmount}</td>
                        <td>{itm.discount}</td>
                        <td>{itm.discountAmount}</td>
                        <td>{itm.totalLineAmount}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            <div className="row">
              <p className="col-md-6">
                Total Amount: {selectedData.totalAmount}
              </p>
              <p className="col-md-6">Tax : {selectedData.taxName}</p>
              <p className="col-md-6">Tax Amount: {selectedData.taxAmount}</p>
            </div>
            <div className="row">
              <p className="col-md-6">
                frieght Charges: {selectedData.frieghtCharges}
              </p>
              <p className="col-md-6">
                Order Total Value : {selectedData.totalSalesOrderValue}
              </p>
              <p className="col-md-6">Currency: {selectedData.currencyName}</p>
            </div>
          </div>
        )}
      </Modal>

      {pdfView && (
        <Modal isOpen={true} style={customModalStyles}>
          <div className="pdf-main-container ">
            <div className="row no-print">
              <div className="col-md-11"></div>
              <div className="col-md-1">
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setPdfView(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>
            </div>

            <div className="pdf-container mx-3 my-4" ref={pdfContainerRef}>
              <section className="content">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-12">
                      {/* Main content */}
                      <div className="invoice p-3 mb-3">
                        {/* title row */}
                        <div className="row">
                          <div className="col-12">
                            <h4>
                              <img
                                src={`${process.env.REACT_APP_FILE_URL}${
                                  orgData && orgData.organizationIcon
                                }`}
                                width="50"
                                height="50"
                                alt=""
                              />
                              &nbsp;Sales Order
                            </h4>
                          </div>
                          {/* /.col */}
                        </div>
                        {/* info row */}
                        <div className="row invoice-info">
                          <div className="col-sm-4 invoice-col">
                            From
                            <address>
                              <strong>{orgData && orgData.orgName}</strong>
                              <br />
                              {orgData && orgData.city}{" "}
                              {orgData && orgData.state}
                              <br />
                              {orgData && orgData.country}{" "}
                              {orgData && orgData.zipCode}
                              <br />
                              Phone: {orgData && orgData.phoneNumber}
                              <br />
                              Email: {orgData && orgData.orgEmail}
                            </address>
                          </div>
                          {/* /.col */}
                          <div className="col-sm-4 invoice-col">
                            To
                            <address>
                              <strong>{pdfData && pdfData.name}</strong>
                              <br />
                              Customer Code: {pdfData && pdfData.customerCode}
                              <br />
                              Phone: {pdfData && pdfData.workContactNumber}
                              <br />
                              Email: {pdfData && pdfData.customerEmailId}
                            </address>
                          </div>
                          {/* /.col */}
                          <div className="col-sm-4 invoice-col">
                            <br />
                            <b>Order Date:</b> {pdfData && pdfData.date}
                            <br />
                            <b>Order No:</b> {pdfData && pdfData.salesOrderCode}
                            <br />
                            <b>Currency:</b> {pdfData && pdfData.currencyName}
                            <br />
                            <b>Expected Delivery:</b>
                            {pdfData && pdfData.expectedDate}
                            <br />
                          </div>
                          {/* /.col */}
                        </div>
                        {/* /.row */}
                        {/* Table row */}
                        <div className="row">
                          <div className="col-12 table-responsive">
                            <table className="table table-striped table-bordered">
                              <thead>
                                <tr>
                                  <th>Sr.No</th>
                                  {/* <th>Item Type</th> */}
                                  <th>Item Description</th>
                                  <th>Item Unit Price</th>
                                  <th>Rate</th>
                                  <th>Quantity</th>

                                  <th>Amount</th>
                                  <th>Discount</th>

                                  <th>Sub Total</th>
                                </tr>
                              </thead>
                              <tbody>
                                {pdfData.salesOrderProducts &&
                                  pdfData.salesOrderProducts.map((itm, i) => {
                                    return (
                                      <tr key={i}>
                                        <td>{i + 1}</td>

                                        {/* <td>{itm.productSubTypeName}</td> */}
                                        <td>{itm.productName}</td>
                                        <td>{itm.itemUnitPrice}</td>
                                        <td>{itm.rate}</td>
                                        <td>
                                          {itm.salesOrderQuantity +
                                            " " +
                                            itm.unitAbbreviation}
                                        </td>

                                        <td>{itm.subTotalAmount}</td>
                                        <td>
                                          {itm.discountAmount} ({itm.discount}%)
                                        </td>

                                        <td>{itm.totalLineAmount}</td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </table>
                          </div>
                          {/* /.col */}
                        </div>
                        {/* /.row */}
                        <div className="row">
                          <div className="col-6">
                            <p className="text-muted well well-sm shadow-none">
                              Remark/Note:
                            </p>
                            <p> {pdfData && pdfData.remark}</p>
                            <hr />
                            <p
                              className="text-muted well well-sm shadow-none"
                              style={{ marginTop: 10 }}
                            >
                              Name of Authorized Signatory:
                            </p>
                            <hr />

                            <p
                              className="text-muted well well-sm shadow-none"
                              style={{ marginTop: 10 }}
                            >
                              This is Computer Generated Document
                            </p>
                          </div>

                          <div className="col-6">
                            <div className="table-responsive">
                              <table className="table">
                                <tbody className="text-right">
                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      Total Amount:
                                    </th>
                                    <td> {pdfData && pdfData.totalAmount}</td>
                                  </tr>
                                  <tr>
                                    <th>
                                      Tax Amount (
                                      {pdfData && pdfData.taxPercentage}%)
                                    </th>
                                    <td> {pdfData && pdfData.taxAmount}</td>
                                  </tr>
                                  <tr>
                                    <th>Frieght Charges :</th>
                                    <td>
                                      {" "}
                                      {pdfData && pdfData.frieghtCharges}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>Total Cost:</th>
                                    <td>
                                      {" "}
                                      {pdfData && pdfData.totalSalesOrderValue}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
          <div className="row no-print">
            <div className="col-12">
              {/* <a
                href=""
                rel="noopener"
                target="_blank"
                className="btn btn-default print-button"
                onClick={() => printPdfContainer()}
              >
                <i className="fas fa-print" /> Print
              </a> */}

              <button
                type="button"
                className="btn btn-primary float-right generate-pdf-button"
                style={{ marginRight: 5 }}
                onClick={() => generatePDF(pdfData && pdfData.salesOrderCode)}
              >
                <i className="fas fa-download" /> Generate PDF
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default SalesOrderList;
